import { Customer, CustomerITA } from 'services/api/entities/crm/pmi'
import { yupString } from 'services/yup/custom-schemas/string'
import { YupSchema } from 'services/yup/types'
import { customerBaseVS } from './customerBase'
import { yupObject } from 'services/yup/custom-schemas/object'
import { yupBoolean, yupIgnore } from 'services/yup'

export const customerVS: YupSchema<Customer> = customerBaseVS.shape({
  email: yupString().required(),
  phone: yupString().required(),
  address: yupString(),
  promotionalActivitiesConsensus: yupBoolean().required(),
  profilingConsensus: yupBoolean().required(),
  dataProcessingConsensus: yupIgnore(),
  createdAt: yupIgnore(),
  lastLogin: yupIgnore(),
  emailVerified: yupIgnore(),
  externalUserId: yupIgnore(),
  phoneVerified: yupIgnore(),
  organizationNumber: yupString(),
  membership: yupObject(),
})

export const customerITAVS: YupSchema<CustomerITA> = customerVS.shape({
  vat: yupString().required(),
  pec: yupString().required(),
  sdi: yupString().required(),
})
